import { render, staticRenderFns } from "./BidProjects.vue?vue&type=template&id=4c076954&scoped=true"
import script from "./BidProjects.vue?vue&type=script&lang=js"
export * from "./BidProjects.vue?vue&type=script&lang=js"
import style0 from "./BidProjects.vue?vue&type=style&index=0&id=4c076954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c076954",
  null
  
)

export default component.exports